import { render, staticRenderFns } from "./paymentDetails.vue?vue&type=template&id=53cb53f6&"
import script from "./paymentDetails.vue?vue&type=script&lang=js&"
export * from "./paymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./paymentDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports